import css from 'styled-jsx/css';
import { rgba } from 'common/styling/theme';

const staticStyles = css.global`
  .TwoStepRegisterModal {
    h2 {
      font-weight: 500;
    }

    .PanelTabs__button {
      font-size: 16px;
    }

    &__caption {
      margin-bottom: 16px;
    }
  }

  :global(.ReactModal__Content) {
    max-width: 620px !important;
    width: 100%;
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .TwoStepRegisterModal {
      &__caption {
        color: ${rgba([colors.black.rgb, 0.75])};
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
